export default __webpack_public_path__ + "static/media/Svg.db12a430.svg";